import React, { useEffect } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    useEffect(() => {
        // Verificar o perfil do usuário e redirecionar
        try {
            const usuarioJSON = localStorage.getItem("usuarioWGSol");
            if (usuarioJSON) {
                const usuario = JSON.parse(usuarioJSON);
                
                if (usuario.autoridades && usuario.autoridades.length > 0) {
                    // Verificar se o usuário possui APENAS o perfil TECNICO
                    const perfis = usuario.autoridades.map(auth => auth.authority || auth);
                    const apenasTenico = perfis.length === 1 && perfis[0].includes("TECNICO");
                    
                    if (apenasTenico) {
                        // Redirecionar para agenda
                        window.location.href = "/agenda";
                    } else {
                        // Redirecionar para ordens
                        window.location.href = "/ordens";
                    }
                }
            }
        } catch (error) {
            console.error("Erro ao verificar perfil do usuário:", error);
        }
    }, [navigate]);
    return (
        <>
            
        </>
    );
}
